import { SettingCard, SettingCardRow } from '@components/Dashboard/components'
import { DASHBOARD_MEMBERS_LINK } from '@components/Router/constants'
import type { ID } from '@octopus-do/octopus-project-core'
import { AngleRight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { Link } from 'react-router-dom'

import css from './styles.module.css'

interface Props {
  workspaceId: ID
}

export const MembersCard: React.FC<Props> = ({ workspaceId }) => {
  return (
    <SettingCard title="Members">
      <SettingCardRow
        title="Team members"
        description="Invite teammates and manage their access."
      >
        <Link
          to={`${DASHBOARD_MEMBERS_LINK}/${workspaceId}`}
          className={css.members_button}
        >
          Manage members <AngleRight />
        </Link>
      </SettingCardRow>
    </SettingCard>
  )
}
